import * as React from "react";

function UpRightFromSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M488 0H352.7c-13.25 0-25.09 7.906-30.19 20.16-5.062 12.28-2.281 26.25 7.094 35.63l40.69 40.69L177.4 289.4c-12.5 12.5-12.5 32.75 0 45.25 6.2 6.25 14.4 9.35 22.6 9.35s16.38-3.125 22.62-9.375l192.9-192.9 40.69 40.69C462.5 188.7 470.8 192 479.3 192a32.85 32.85 0 0 0 12.56-2.5c12.24-5.1 20.14-16.9 20.14-30.2V24c0-13.25-10.7-24-24-24zm-96 320c-13.25 0-24 10.75-24 24v112c0 4.406-3.594 8-8 8H56c-4.406 0-8-3.594-8-8V152c0-4.406 3.594-8 8-8h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-30.87 0-56 25.1-56 56v304c0 30.9 25.13 56 56 56h304c30.88 0 56-25.12 56-56V344c0-13.2-10.7-24-24-24z"
  }));
}

const ForwardRef = React.forwardRef(UpRightFromSquareIcon);
export default ForwardRef;